import React, { useEffect, useState } from 'react';
import { Dumbbell } from 'lucide-react';

// Only show the splash screen once per browser session
const SESSION_KEY = 'fittrack_splash_shown';

const SplashScreen: React.FC = () => {
  const [isVisible, setIsVisible] = useState(() => {
    if (sessionStorage.getItem(SESSION_KEY)) return false;
    sessionStorage.setItem(SESSION_KEY, '1');
    return true;
  });

  useEffect(() => {
    if (!isVisible) return;
    const timer = setTimeout(() => setIsVisible(false), 2000);
    return () => clearTimeout(timer);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-app animate-fade-in">
      <div className="text-center">
        <div className="relative flex items-center justify-center">
          {/* Pulse ring */}
          <div className="absolute w-32 h-32 border-2 border-accent/30 rounded-full animate-ping" />
          {/* Icon */}
          <div className="relative bg-accent/10 border border-accent/20 rounded-full p-8 shadow-2xl animate-scale-in">
            <Dumbbell className="h-16 w-16 text-accent" />
          </div>
        </div>

        <h1 className="mt-8 text-4xl font-black text-ink animate-slide-up">FitTrack</h1>
        <p className="mt-2 text-ink-muted text-sm animate-slide-up" style={{ animationDelay: '0.1s' }}>
          Your fitness journey starts here
        </p>

        <div className="mt-8 flex justify-center gap-1.5">
          {[0, 0.15, 0.3].map((delay, i) => (
            <div
              key={i}
              className="w-1.5 h-1.5 bg-accent rounded-full animate-bounce"
              style={{ animationDelay: `${delay}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
